<script setup>

throw new Error('Memo component not implemented yet');
</script>

<template>
    <div>I am the memo component, </div>
</template>

<style lang="scss">
@use "styles";
</style>
